module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.toggleShow
    }
  }, [_vm._v("设置头像")]), _vm._v(" "), _c('my-upload', {
    attrs: {
      "field": "img",
      "width": 300,
      "height": 300,
      "url": "/upload",
      "params": _vm.params,
      "headers": _vm.headers,
      "img-format": "png"
    },
    on: {
      "crop-success": _vm.cropSuccess,
      "crop-upload-success": _vm.cropUploadSuccess,
      "crop-upload-fail": _vm.cropUploadFail
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgDataUrl
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dab1b44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/upload.vue
// module id = 832
// module chunks = 1